import {inject, observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import FileUploadModalBodyUI from '../view/FileUploadModalBodyUI';
import MyLibraryModalStore from '../../MyLibraryModal/store/MyLibraryModalStore';
import {useParams} from 'react-router-dom';
import {fileUploadText} from '../fileUploadText';
import {toast} from 'react-toastify';
import {toastConfig} from '../../../uiToolkit/Toast/toastConfig';
import {MediaFile} from '../../../data/models/LibraryFile/MediaFile';

interface Props {
  file: File;
  myLibraryModalStore?: MyLibraryModalStore;
  onSuccess: (uploaded?: MediaFile) => void;
  onClose: () => void;
  onCollect?: (duration: number, targetRes: number) => void;
  position?: number;
  total?: number;
  initialRes?: number;
  onBack?: () => void;
  isUploading?: boolean;
}

const FileUploadModalBodyContainer = inject('myLibraryModalStore')(
  observer(
    ({
      myLibraryModalStore,
      file,
      onSuccess,
      onClose,
      onCollect,
      position,
      total,
      initialRes,
      onBack,
      isUploading,
    }: Props) => {
      const {organizationId} = useParams();
      const [maxAllowedRes, setMaxAllowedRes] = useState(0);
      const [isLoading, setIsLoading] = useState(true);

      useEffect(() => {
        setIsLoading(true);
        if (!file.type.includes('video') && organizationId) {
          myLibraryModalStore!
            .uploadLibraryFile(organizationId, file, 0, 0)
            .then(uploaded => {
              if (uploaded) {
                toast.success(fileUploadText.videoUploaded, toastConfig);
                onSuccess(uploaded);
              } else {
                onClose();
              }
            });
        } else if (organizationId) {
          myLibraryModalStore!
            .getMaxAllowedResolution(organizationId)
            .then(setMaxAllowedRes);
          setIsLoading(false);
        }
      }, []);

      const onFileUpload = (duration: number, targetRes: number) => {
        if (onCollect) {
          onCollect(duration, targetRes);
          return;
        }
        if (organizationId) {
          myLibraryModalStore!
            .uploadLibraryFile(organizationId, file, duration, targetRes)
            .then(uploaded => {
              if (uploaded) {
                toast.success(fileUploadText.videoUploaded, toastConfig);
                onSuccess(uploaded);
              } else {
                onClose();
              }
            });
        }
      };

      return (
        <FileUploadModalBodyUI
          file={file}
          onFileUpload={onFileUpload}
          isLoading={myLibraryModalStore!.isLoading}
          nonVideoLoading={isLoading}
          maxAllowedRes={maxAllowedRes}
          onClose={onClose}
          position={position}
          total={total}
          initialRes={initialRes}
          onBack={onBack}
          isUploading={isUploading}
        />
      );
    },
  ),
);

export default FileUploadModalBodyContainer;
